<div [class.hidden]="hidden">
  @if (label) {
    <ion-label>
      {{ label }}
    </ion-label>
  }
  <div class="input-wrapper"
    [class.no-border]="noBorder"
    [class.error]="hasErrors">
    @if (iconStart) {
      <c-icon class="icon-start" [icon]="icon" [color]="iconColor" />
    }

    <ion-input
      #input
      [type]="type"
      [inputmode]="inputMode"
      placeholder="{{ placeholder | transloco }}"
      [readonly]="readonly"
      [formControl]="control"
      [maxlength]="maxLength"
      [minlength]="minLength"
      [clearInput]="clearInput"
      [maskito]="maskito"
      [maskitoElement]="maskPredicate"
      />
    @if (loading) {
      <c-spinner [loading]="loading"></c-spinner>
    } @else {
      @if (icon && !iconStart) {
        <c-icon class="icon-end" [icon]="icon" [color]="iconColor" (action)="iconClick()" />
      }
    }
  </div>
</div>

@if (hasErrors) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
  </div>
}

